import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const IdentificationContent = ({data}) => {

    useEffect(() => {
        const values = [];
        const labels = [];

        const sorted = data.attendanceAnonymousAndIdenfied?.sort((a, b) => b.qty - a.qty);

        sorted.forEach((item) => {
            labels.push(ReportUtils.formatText(item.text));
            values.push(item.qty);
        });

        ReportUtils.createExportableTable(labels, values, "Identificação dos solicitantes");
        GraphicUtils.horizontalBarChart('attendance-anonymous-and-identified', values, labels, true);
    }, [data]);

    return (
        <>
            <div className="chart-report duo-bar-chart align-center">
                <div className="chart-title text-center mb-2">Identificação do solicitante nos atendimentos</div>
                <div className="chart-report bar-chart" id="attendance-anonymous-and-identified"></div>
            </div>
        </>
    );
};

export default IdentificationContent;